<template lang="pug">
    div
        List(item-layout="vertical")
            ListItem(v-for="(netflowIpListGroup, index) in value" :key="index")
                ListItemMeta(
                    :title="netflowIpListGroup.name"
                    :description="`IP: ${netflowIpListGroup.ips}`.replaceAll(`\n`,`, `)"
                )
                template(slot="action")
                    li
                        div {{ `CIR: ${netflowIpListGroup.cir || ""} Mbps` }}
                    li
                        div {{ `PIR: ${netflowIpListGroup.pir || ""} Mbps` }}
                    li
                        div {{ `CUS: ${netflowIpListGroup.cus || ""} Mbps` }}
                template(slot="extra")
                    Button(@click="openModal(true, index)") {{ $t("rcmtable.editText") }}
                    Button(@click="removeNetflowListGroup(index)") {{ $t("rcmtable.deleteText") }}
        Button(@click="openModal(false)") {{ $t("rcmtable.addTagText") }}
    
        Modal(
            v-model="isModalVisible"
            :title="isEditMode ? 'Edit Netflow IP List Group' : 'Add Netflow IP List Group'"
            :mask-closable="false"
        )
            Form(ref="netflowForm" :model="formData" :rules="validateRule" :label-width="80")
                FormItem(prop="name" label="Name")
                    Input(v-model="formData.name" style="width:400px")
                FormItem(prop="ips" label="IP List")
                    Input(
                        type="textarea"
                        v-model="formData.ips"
                        :rows="4"
                        style="width:400px"
                        placeholder="x.x.x.x/netmask\nx.x.x.x/netmask"
                    )
                FormItem(prop="cir" label="CIR")
                    Input(v-model="formData.cir" style="width:100px")
                    span  Mbps
                FormItem(prop="pir" label="PIR")
                    Input(v-model="formData.pir" style="width:100px")
                    span  Mbps
                FormItem(prop="cus" label="CUS")
                    Input(v-model="formData.cus" style="width:100px")
                    span  Mbps
            div(slot="footer")
                Button(@click="confirmModal") {{ $t("rcmtable.confirmText") }}
                Button(@click="cancelModal") {{ $t("rcmtable.cancelText") }}
</template>

<script>
import { ipValidate } from "@/api/formValidate";

export default {
    name: "NetflowIpListGroup",
    props: {
        value: {
            default: () => [],
        },
    },
    data() {
        return {
            isModalVisible: false,
            isEditMode: false,
            editingIndex: null,
            formData: this.getEmptyFormData(),
            validateRule: {
                name: [{ required: true, message: this.$t("rcmtable.validateEmptyText"), trigger: "blur" }],
                ips: [
                    { required: true, message: this.$t("rcmtable.validateEmptyText"), trigger: "blur" },
                    {
                        validator: (rule, value, callback) => {
                            const networks = value.split("\n");
                            // 判斷是否有重複 IP
                            const hasDuplicate = networks.some((e, i) => networks.indexOf(e) !== i);
                            if (hasDuplicate) return callback(new Error("Duplicate IP entry found"));

                            // 驗證每一筆 network
                            ipValidate("network", networks).then((result) => {
                                if (!result.data.success) {
                                    return callback(new Error(result.data.message));
                                }
                                callback();
                            });
                        },
                        trigger: "blur",
                    },
                ],
                cir: [{ validator: this.positiveIntegerValidator("CIR"), trigger: "blur" }],
                pir: [{ validator: this.positiveIntegerValidator("PIR"), trigger: "blur" }],
                cus: [{ validator: this.positiveIntegerValidator("CUS"), trigger: "blur" }],
            },
        };
    },
    methods: {
        getEmptyFormData() {
            return { name: "", ips: "", cir: "", pir: "", cus: "" };
        },
        positiveIntegerValidator(label) {
            return (rule, value, callback) => {
                // 空值不驗證，代表非必填
                if (value === undefined || value === null || value === "") return callback();
                const valid = /^[1-9]\d*$/.test(String(value).trim());
                if (!valid) return callback(new Error(`${label} ${this.$t("rcmtable.positiveInteger")}`));
                callback();
            };
        },
        openModal(isEdit, index = null) {
            this.isEditMode = isEdit;
            this.isModalVisible = true;

            // 開啟後，清除上次驗證狀態
            this.$nextTick(() => {
                if (this.$refs.netflowForm) {
                    this.$refs.netflowForm.resetFields();
                    // 這一步會清除驗證訊息，也會清掉表單值
                    // 所以我們再還原 formData
                    if (isEdit && index !== null) {
                        this.formData = { ...this.value[index] };
                    }
                }
            });

            if (!isEdit || index === null) {
                this.formData = this.getEmptyFormData();
                return;
            }
            this.editingIndex = index;
            this.formData = { ...this.value[index] };
        },
        confirmModal() {
            this.$refs.netflowForm.validate((valid) => {
                if (!valid) return;
                this.updateNetflowList();
                this.cancelModal();
            });
        },
        updateNetflowList() {
            const newList = [...this.value];
            if (this.isEditMode) {
                newList[this.editingIndex] = { ...this.formData };
                return this.$emit("input", newList);
            }
            newList.push({ ...this.formData });
            this.$emit("input", newList);
        },
        cancelModal() {
            // 只清除驗證狀態，不清空 formData
            if (this.$refs.netflowForm) {
                const currentFormData = { ...this.formData };
                this.$refs.netflowForm.resetFields();
                this.formData = currentFormData; // 還原內容
            }
            this.isModalVisible = false;
            this.$emit("modalSubmitComplete");
        },
        removeNetflowListGroup(index) {
            const newList = [...this.value];
            newList.splice(index, 1);
            this.$emit("input", newList);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/NetflowIpListGroup.vue